<template>
  <v-app>
    <v-main>
      <v-toolbar border>
        <v-toolbar-title @click="$router.push('/about')" style="cursor: pointer; width: auto">Matúš Gál
        </v-toolbar-title>
        <v-spacer/>
        <v-btn
            to="/projects"
        >
          Projects
        </v-btn>
        <v-btn
            to="/about"
        >
          About Me
        </v-btn>
      </v-toolbar>
      <router-view/>
    </v-main>
    <v-footer
        color="dark"
        border
        class="mt-1"
        style="max-height: 6%; width: 100%; position: fixed; bottom: 0"
    >
      <v-row>
        <v-col
            cols="12"
            class="text-center"
            style="color: white"
        >
          2023 by Matúš Gál
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({})
}
</script>

<style>
@font-face {
  font-family: "dudu";
  src: local("dudu"),
  url(@/assets/fonts/Dudu_Calligraphy.ttf) format("truetype");
}

.description {
  display: inline-block;
  max-width: 100%; /* Ensure the span doesn't exceed its container */
  overflow: auto; /* or any other overflow value: hidden, scroll, etc. */
  /* Additional styling properties */
  padding-bottom: 2%;
  /* Add padding, margin, etc. as needed */
}
</style>
